import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_Can = _resolveComponent("Can")!
  const _component_LabelCustom = _resolveComponent("LabelCustom")!
  const _component_ResponsiveLayout = _resolveComponent("ResponsiveLayout")!
  const _component_BaseLink = _resolveComponent("BaseLink")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_PageContentSection = _resolveComponent("PageContentSection")!
  const _component_DinhMucCoDinhSection = _resolveComponent("DinhMucCoDinhSection")!
  const _component_PageContentBase = _resolveComponent("PageContentBase")!

  return (_openBlock(), _createBlock(_component_PageContentBase, { plain: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_PageContentSection, { alwaysExpanded: true }, {
        header: _withCtx(() => [
          _createTextVNode("Chi tiết")
        ]),
        actions: _withCtx(() => [
          _createVNode(_component_Can, {
            all: [_ctx.KE_HOACH_SUA_CHUA.SUA]
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ButtonCustom, {
                "button-type": _ctx.ButtonsType.EDIT,
                classes: `rounded-none m-0`,
                "color-type": _ctx.ButtonTypeColors.SUCCESS,
                "tooltip-message": "Chỉnh sửa kế hoạch",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.push(`/quan-ly/ke-hoach-nam/chinh-sua/${_ctx.idKeHoach}`)))
              }, null, 8, ["button-type", "color-type"])
            ]),
            _: 1
          }, 8, ["all"]),
          _createVNode(_component_Can, {
            all: [_ctx.KE_HOACH_SUA_CHUA.XOA]
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ButtonCustom, {
                "button-type": _ctx.ButtonsType.TRASH,
                classes: `rounded-none m-0`,
                "color-type": _ctx.ButtonTypeColors.DANGER,
                "tooltip-message": "Xoá kế hoạch",
                onClick: _ctx.onDeleteKeHoachButtonClick
              }, null, 8, ["button-type", "color-type", "onClick"])
            ]),
            _: 1
          }, 8, ["all"])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_ResponsiveLayout, null, {
            "col-1": _withCtx(() => [
              _createVNode(_component_LabelCustom, { "is-text-muted": "" }, {
                default: _withCtx(() => [
                  _createTextVNode("ID:")
                ]),
                _: 1
              })
            ]),
            "col-2": _withCtx(() => [
              _createVNode(_component_LabelCustom, { "is-bolder": "" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.keHoachDetail?.id), 1)
                ]),
                _: 1
              })
            ]),
            "col-3": _withCtx(() => [
              _createVNode(_component_LabelCustom, { "is-text-muted": "" }, {
                default: _withCtx(() => [
                  _createTextVNode("Ngày tạo:")
                ]),
                _: 1
              })
            ]),
            "col-4": _withCtx(() => [
              _createVNode(_component_LabelCustom, { "is-bolder": "" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.moment(_ctx.keHoachDetail?.created_at).format('DD/MM/YYYY')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ResponsiveLayout, null, {
            "col-1": _withCtx(() => [
              _createVNode(_component_LabelCustom, { "is-text-muted": "" }, {
                default: _withCtx(() => [
                  _createTextVNode("Cấp SC:")
                ]),
                _: 1
              })
            ]),
            "col-2": _withCtx(() => [
              _createVNode(_component_BaseLink, {
                to: {
              name: 'chi-tiet-cap-sua-chua',
              params: { id: _ctx.keHoachDetail?.cap_sua_chua.id },
            }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.keHoachDetail?.cap_sua_chua.ten_cap_sc), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            "col-3": _withCtx(() => [
              _createVNode(_component_LabelCustom, { "is-text-muted": "" }, {
                default: _withCtx(() => [
                  _createTextVNode("Nhóm toa xe:")
                ]),
                _: 1
              })
            ]),
            "col-4": _withCtx(() => [
              (_ctx.keHoachDetail)
                ? (_openBlock(), _createBlock(_component_BaseLink, {
                    key: 0,
                    to: {
              name: 'chi-tiet-danh-muc-toa-xe',
              params: { id: _ctx.keHoachDetail.danh_muc_toa_xe.id },
            }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.keHoachDetail?.danh_muc_toa_xe.ten_danh_muc), 1)
                    ]),
                    _: 1
                  }, 8, ["to"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_ResponsiveLayout, null, {
            "col-1": _withCtx(() => [
              _createVNode(_component_LabelCustom, { "is-text-muted": "" }, {
                default: _withCtx(() => [
                  _createTextVNode("Số lượng toa:")
                ]),
                _: 1
              })
            ]),
            "col-2": _withCtx(() => [
              _createVNode(_component_LabelCustom, { "is-bolder": "" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.keHoachDetail?.so_luong_toa_xe) + " toa", 1)
                ]),
                _: 1
              })
            ]),
            "col-3": _withCtx(() => [
              _createVNode(_component_LabelCustom, { "is-text-muted": "" }, {
                default: _withCtx(() => [
                  _createTextVNode("Năm:")
                ]),
                _: 1
              })
            ]),
            "col-4": _withCtx(() => [
              _createVNode(_component_LabelCustom, { "is-bolder": "" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.keHoachDetail?.nam), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ResponsiveLayout, null, {
            "col-1": _withCtx(() => [
              _createVNode(_component_LabelCustom, { "is-text-muted": "" }, {
                default: _withCtx(() => [
                  _createTextVNode("Định mức cố định:")
                ]),
                _: 1
              })
            ]),
            "col-2": _withCtx(() => [
              (_ctx.dinhMucCoDinhhDetail)
                ? (_openBlock(), _createBlock(_component_BaseLink, {
                    key: 0,
                    to: {
              name: 'chi-tiet-dinh-muc-co-dinh',
              params: {
                id: _ctx.dinhMucCoDinhhDetail.id,
              }
            }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.dinhMucCoDinhhDetail.danh_muc_toa_xe.ten_danh_muc) + " (" + _toDisplayString(_ctx.dinhMucCoDinhhDetail.cap_sua_chua.ten_cap_sc) + ") ", 1)
                    ]),
                    _: 1
                  }, 8, ["to"]))
                : (_openBlock(), _createBlock(_component_LabelCustom, {
                    key: 1,
                    "is-text-muted": ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Không có biên bản tương ứng")
                    ]),
                    _: 1
                  }))
            ]),
            "col-3": _withCtx(() => [
              _createVNode(_component_LabelCustom, { "is-text-muted": "" }, {
                default: _withCtx(() => [
                  _createTextVNode("Số văn bản:")
                ]),
                _: 1
              })
            ]),
            "col-4": _withCtx(() => [
              _createVNode(_component_LabelCustom, { "is-bolder": "" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.keHoachDetail?.so_van_ban), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ResponsiveLayout, {
            "has-two-columns": "",
            "align-items": "align-items-start"
          }, {
            "col-1": _withCtx(() => [
              _createVNode(_component_LabelCustom, { "is-text-muted": "" }, {
                default: _withCtx(() => [
                  _createTextVNode("Ghi chú:")
                ]),
                _: 1
              })
            ]),
            "col-2": _withCtx(() => [
              (_ctx.keHoachDetail)
                ? (_openBlock(), _createBlock(_component_el_input, {
                    key: 0,
                    modelValue: _ctx.keHoachDetail.ghi_chu,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.keHoachDetail.ghi_chu) = $event)),
                    rows: 3,
                    type: "textarea",
                    disabled: ""
                  }, null, 8, ["modelValue"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_ctx.keHoachDetail)
        ? (_openBlock(), _createBlock(_component_DinhMucCoDinhSection, {
            key: 0,
            "button-tooltip-message": "Tạo phiếu xuất",
            idCapSuaChua: _ctx.keHoachDetail.id_cap_sc,
            idDanhMucToaXe: _ctx.keHoachDetail.id_danh_muc_toa_xe,
            "show-create-phieu-xuat-button": false,
            "status-filter": "valid"
          }, null, 8, ["idCapSuaChua", "idDanhMucToaXe"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}